import { render, staticRenderFns } from "./logo-upload.vue?vue&type=template&id=1b001086&"
import script from "./logo-upload.vue?vue&type=script&lang=js&"
export * from "./logo-upload.vue?vue&type=script&lang=js&"
import style0 from "./logo-upload.vue?vue&type=style&index=0&id=1b001086&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports